import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const adminApi = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api' });

const AdminPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState(localStorage.getItem('admin_token') || '');
  const [users, setUsers] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [searches, setSearches] = useState<any[]>([]);
  const [tab, setTab] = useState('stats');
  const [error, setError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [showPwForm, setShowPwForm] = useState(false);
  const navigate = useNavigate();

  const login = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await adminApi.post('/admin/login', { email, password });
      setToken(res.data.token);
      localStorage.setItem('admin_token', res.data.token);
      setError('');
    } catch {
      setError('Λάθος email ή password');
    }
  };

  useEffect(() => {
    if (!token) return;
    const headers = { Authorization: `Bearer ${token}` };
    Promise.all([
      adminApi.get('/admin/stats', { headers }),
      adminApi.get('/admin/users', { headers }),
      adminApi.get('/admin/search-logs', { headers }),
    ]).then(([s, u, sl]) => {
      setStats(s.data);
      setUsers(u.data);
      setSearches(sl.data);
    }).catch((err) => {
      if (err.response && err.response.status === 401) {
        setToken('');
        localStorage.removeItem('admin_token');
      }
    });
  }, [token]);

  const logout = () => {
    setToken('');
    localStorage.removeItem('admin_token');
  };

  const changePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== newPassword2) {
      setPwMsg('Τα passwords δεν ταιριάζουν');
      return;
    }
    if (newPassword.length < 6) {
      setPwMsg('Τουλάχιστον 6 χαρακτήρες');
      return;
    }
    try {
      await adminApi.post('/admin/set-password', { password: newPassword }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPwMsg('OK');
      setNewPassword('');
      setNewPassword2('');
      setTimeout(() => { setShowPwForm(false); setPwMsg(''); }, 2000);
    } catch {
      setPwMsg('ERROR');
    }
  };

  if (!token) return (
    <div style={S.loginWrap}>
      <div style={S.loginCard}>
        <h2 style={S.title}>Admin Panel</h2>
        {error && <div style={S.error}>{error}</div>}
        <form onSubmit={login}>
          <input style={S.input} type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={S.input} type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
          <button style={S.btn} type="submit">Σύνδεση</button>
        </form>
      </div>
    </div>
  );

  return (
    <div style={S.page}>
      <div style={S.header}>
        <h1 style={S.title}>Admin Panel SmartKalathi</h1>
        <div style={{ display: 'flex', gap: 12 }}>
          <button onClick={() => navigate('/')} style={S.btnOut}>Home</button>
          <button onClick={() => setShowPwForm(!showPwForm)} style={S.btnOut}>Αλλαγή Password</button>
          <button onClick={logout} style={S.btnOut}>Logout</button>
        </div>
      </div>

      {showPwForm && (
        <div style={S.pwCard}>
          <h3 style={{ margin: '0 0 12px', color: '#2952CC', fontSize: 15 }}>Αλλαγή Password</h3>
          <form onSubmit={changePassword} style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' as const }}>
            <input style={{ ...S.input, width: 200, marginBottom: 0 }} type="password" placeholder="Νέο password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
            <input style={{ ...S.input, width: 200, marginBottom: 0 }} type="password" placeholder="Επανάληψη" value={newPassword2} onChange={e => setNewPassword2(e.target.value)} required />
            <button style={{ ...S.btn, width: 'auto', padding: '10px 20px' }} type="submit">Αποθήκευση</button>
            <button type="button" onClick={() => { setShowPwForm(false); setPwMsg(''); }} style={{ ...S.btnOut, padding: '10px 16px' }}>Άκυρο</button>
          </form>
          {pwMsg && <div style={{ marginTop: 10, fontSize: 13, color: pwMsg === 'OK' ? '#27AE60' : '#E74C3C' }}>{pwMsg === 'OK' ? 'Password άλλαξε επιτυχώς!' : pwMsg === 'ERROR' ? 'Σφάλμα αλλαγής password' : pwMsg}</div>}
        </div>
      )}

      {stats && (
        <div style={S.statsRow}>
          <div style={S.statCard}><div style={S.statNum}>{stats.total_users}</div><div style={S.statLabel}>Χρήστες</div></div>
          <div style={S.statCard}><div style={S.statNum}>{stats.total_searches}</div><div style={S.statLabel}>Αναζητήσεις</div></div>
          <div style={S.statCard}><div style={S.statNum}>{stats.total_products}</div><div style={S.statLabel}>Προϊόντα</div></div>
        </div>
      )}

      <div style={S.tabs}>
        {['stats', 'users'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ ...S.tab, ...(tab === t ? S.tabActive : {}) }}>
            {{ stats: 'Στατιστικά', users: 'Χρήστες', searches: 'Αναζητήσεις' }[t]}
          </button>
        ))}
      </div>

      {tab === 'users' && (
        <div style={S.tableWrap}>
          <table style={S.table}>
            <thead><tr>
              <th style={S.th}>Email</th>
              <th style={S.th}>Role</th>
              <th style={S.th}>Επισκέψεις</th>
              <th style={S.th}>Τελευταία Σύνδεση</th>
              <th style={S.th}>Εγγραφή</th>
            </tr></thead>
            <tbody>
              {users.map(u => (
                <React.Fragment key={u.id}>
                  <tr>
                    <td style={S.td}>{u.email}</td>
                    <td style={S.td}><span style={u.role === 'admin' ? S.badgeAdmin : S.badgeUser}>{u.role}</span></td>
                    <td style={S.td}>{u.visit_count || 0}</td>
                    <td style={S.td}>{u.last_login ? new Date(u.last_login).toLocaleString('el-GR') : '—'}</td>
                    <td style={S.td}>{new Date(u.created_at).toLocaleString('el-GR')}</td>
                  </tr>
                  {searches.filter(s => s.email === u.email).length > 0 && (
                    <tr>
                      <td colSpan={5} style={{...S.td, background: '#F8FBFD', fontSize: 12, color: '#555'}}>
                        {searches.filter(s => s.email === u.email).map(s => s.search_query).join(' · ')}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'searches' && (
        <div style={S.tableWrap}>
          <table style={S.table}>
            <thead><tr>
              <th style={S.th}>Email</th>
              <th style={S.th}>Αναζήτηση</th>
              <th style={S.th}>Αποτελέσματα</th>
              <th style={S.th}>Ώρα</th>
            </tr></thead>
            <tbody>
              {searches.map(s => (
                <tr key={s.id}>
                  <td style={S.td}>{s.email || '—'}</td>
                  <td style={S.td}>{s.search_query}</td>
                  <td style={S.td}>{s.results_count}</td>
                  <td style={S.td}>{new Date(s.created_at).toLocaleString('el-GR')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'stats' && stats && (
        <div style={{ padding: 20, background: 'white', borderRadius: 10 }}>
          <p>Σύνολο χρηστών: <strong>{stats.total_users}</strong></p>
          <p>Σύνολο αναζητήσεων: <strong>{stats.total_searches}</strong></p>
          <p>Σύνολο προϊόντων: <strong>{stats.total_products}</strong></p>
        </div>
      )}
    </div>
  );
};

const S: Record<string, React.CSSProperties> = {
  loginWrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F0F4F8' },
  loginCard: { background: 'white', borderRadius: 12, padding: 32, width: 360, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' },
  page: { maxWidth: 1100, margin: '0 auto', padding: '24px 16px', fontFamily: 'Arial, sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 },
  title: { color: '#2952CC', fontSize: 22, fontWeight: 700, margin: 0 },
  error: { background: '#FEF9F9', color: '#E74C3C', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 },
  input: { width: '100%', padding: '10px 12px', borderRadius: 6, border: '1.5px solid #C5D5FF', fontSize: 14, marginBottom: 12, boxSizing: 'border-box' as const },
  btn: { width: '100%', padding: '12px', background: '#2952CC', color: 'white', border: 'none', borderRadius: 6, fontSize: 15, fontWeight: 700, cursor: 'pointer' },
  btnOut: { padding: '8px 16px', background: 'white', color: '#2952CC', border: '1.5px solid #2952CC', borderRadius: 6, cursor: 'pointer', fontSize: 13 },
  pwCard: { background: '#F8FBFD', border: '1.5px solid #C5D5FF', borderRadius: 10, padding: '16px 20px', marginBottom: 20 },
  statsRow: { display: 'flex', gap: 16, marginBottom: 24 },
  statCard: { flex: 1, background: 'white', borderRadius: 10, padding: '16px 20px', textAlign: 'center' as const, boxShadow: '0 2px 8px rgba(0,0,0,0.07)' },
  statNum: { fontSize: 32, fontWeight: 700, color: '#2952CC' },
  statLabel: { fontSize: 13, color: '#888', marginTop: 4 },
  tabs: { display: 'flex', gap: 0, borderBottom: '2px solid #E8EEF2', marginBottom: 16 },
  tab: { padding: '9px 20px', background: 'none', border: 'none', borderBottom: '2px solid transparent', cursor: 'pointer', color: '#888', marginBottom: -2, fontSize: 14 },
  tabActive: { color: '#2952CC', borderBottomColor: '#2952CC', fontWeight: 600 },
  tableWrap: { background: 'white', borderRadius: 10, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.07)' },
  table: { width: '100%', borderCollapse: 'collapse' as const },
  th: { padding: '10px 14px', fontSize: 12, fontWeight: 700, color: '#888', textAlign: 'left' as const, borderBottom: '1px solid #E8EEF2', background: '#F8FBFD' },
  td: { padding: '10px 14px', fontSize: 13, color: '#2952CC', borderBottom: '1px solid #F0F4F8' },
  badgeAdmin: { background: '#2952CC', color: 'white', borderRadius: 4, padding: '2px 8px', fontSize: 11 },
  badgeUser: { background: '#E8EEF2', color: '#888', borderRadius: 4, padding: '2px 8px', fontSize: 11 },
};

export default AdminPage;
